/**
 * Abstract validator options module.
 *
 * @author Kovács Tamás
 * @returns The options of the validator.
 */
function AbstractValidatorOptions() {
    const onclick = false;
    const onfocusout = false;
    const focusCleanup = false;
    const focusInvalid = true;
    const scrollToFirstError = true;
    const showToastMessages = true;
    const scrollToErrorDelay = 0;
    const showToastMessagesOnSuccess = true;
    const showToastMessagesOnError = true;
    // common error container, every error showed in this element
    const errorContainer = null;

    function highlight(element) {
        $(element)
        .parent()
        .addClass('is-invalid');
    }

    function unhighlight(element) {
        $(element)
        .parent()
        .removeClass('is-invalid');
    }

    return {
        onclick,
        onfocusout,
        focusCleanup,
        focusInvalid,
        highlight,
        unhighlight,
        scrollToFirstError,
        showToastMessages,
        showToastMessagesOnSuccess,
        showToastMessagesOnError,
        scrollToErrorDelay,
        errorContainer,
    };
}

export default AbstractValidatorOptions;
